module.exports = __webpack_public_path__ + "static/media/generic.cdd34e02.svg";